<svg width="6" height="4" viewBox="0 0 6 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1L3 3L5 1" stroke="#7285AB" stroke-linecap="round" stroke-linejoin="round"/>
</svg>